/* lv-noel.js — 26/10/2026 (noel-2610), bản 3 27/10 (noel-v3-2710: thanh 1 dòng ưu đãi + hạn theo nhóm size, nhãn Christmas một màu); 02/11 câu quà theo bậc ưu đãi mới QD-2026-11-15. Mọi khối bọc try/catch: lỗi thì bỏ khối đó, không làm hỏng trang. Không thư viện ngoài. */
(() => {
  'use strict';
  const N = window.LV_NOEL;
  if (!N || !N.items) return;
  const dl1 = Date.parse(N.dl1), dl2 = Date.parse(N.dl2);
  const items = new Map(N.items.map(i => [i.h, i]));
  const onColl = location.pathname.indexOf('/collections/' + N.collection) === 0;

  /* 1. Hạn đặt + đếm ngược nhẹ (cập nhật mỗi 30 giây, tạm dừng khi tab ẩn) */
  const phase = () => { const t = Date.now(); return t <= dl1 ? 1 : (t <= dl2 ? 2 : 0); };
  const left = ms => {
    const m = Math.max(0, Math.floor(ms / 60000)), d = Math.floor(m / 1440), h = Math.floor(m / 60);
    if (d >= 2) return d + ' days left';
    if (d === 1) return '1 day ' + (h - 24) + 'h left';
    return h + 'h ' + (m % 60) + 'm left';
  };
  const paint = () => {
    try {
      const p = phase();
      document.querySelectorAll('[data-lv-mto]').forEach(e => { e.hidden = p !== 1; });
      document.querySelectorAll('[data-lv-hide-late]').forEach(b => { b.hidden = p === 0; });
      const main = p === 1 ? 'Order by ' + N.l1 + ' for Christmas delivery'
        : 'In-stock sizes: order by ' + N.l2 + ' for Christmas delivery';
      const sub = p === 1 ? left(dl1 - Date.now()) : (p === 2 ? left(dl2 - Date.now()) : '');
      document.querySelectorAll('[data-lv-dl]').forEach(e => { if (p) e.textContent = main; });
      document.querySelectorAll('[data-lv-left]').forEach(e => { e.textContent = sub ? '· ' + sub : ''; });
      document.querySelectorAll('[data-lv-note]').forEach(e => {
        e.textContent = p === 1
          ? 'Made-to-order sizes are made and shipped to our US warehouse first, so their cutoff comes earlier. In-stock sizes ship in 1–3 business days (order by ' + N.l2 + ' and message us to confirm your size).'
          : 'The made-to-order cutoff (Nov 9) has passed. In-stock sizes still ship in 1–3 business days — message us to confirm your size before you order.';
      });
    } catch (e) { /* bỏ qua */ }
  };
  paint();
  setInterval(() => { if (!document.hidden) paint(); }, 30000);

  /* 2. Thẻ sản phẩm: nhãn "Christmas" đỏ / xanh; vịt + bulldog trong bộ sưu tập Noel dùng ảnh + biến thể Christmas */
  const setImg = (img, url) => {
    if (!img || !url) return;
    img.src = url;
    img.srcset = [165, 360, 535, 750, 940, 1100].map(w => url.replace(/width=[0-9]+/, 'width=' + w) + ' ' + w + 'w').join(', ');
  };
  const decorate = () => {
    try {
      document.querySelectorAll('.m-product-card:not([data-lv-noel])').forEach(card => {
        const a = card.querySelector('a.m-product-card__link');
        const m = a && (a.getAttribute('href') || '').match(/[/]products[/]([^/?#]+)/);
        const it = m && items.get(m[1]);
        if (!it) return;
        card.setAttribute('data-lv-noel', '1');
        if (it.mixed) {
          const sec = card.closest('.shopify-section');
          if (!onColl || !it.v || !sec || !/__main$/.test(sec.id)) return;   // sản phẩm có cả bản thường: chỉ đổi + gắn nhãn ở lưới chính của bộ sưu tập Noel
          card.querySelectorAll('a[href*="/products/"]').forEach(l => { l.href = l.getAttribute('href').split('?')[0] + '?variant=' + it.v; });
          setImg(card.querySelector('.m-product-card__main-image img'), it.i1);
          if (it.i2) setImg(card.querySelector('.m-product-card__hover-image img'), it.i2);
        }
        const media = card.querySelector('.m-product-card__media');
        if (media && !media.querySelector('.lv-noel-tag')) {
          const tag = document.createElement('span');
          tag.className = 'lv-noel-tag';
          tag.textContent = 'Christmas';
          media.appendChild(tag);
        }
      });
    } catch (e) { /* bỏ qua */ }
  };
  decorate();
  let timer = null;
  try { new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(decorate, 150); }).observe(document.body, { childList: true, subtree: true }); } catch (e) { /* bỏ qua */ }

  /* 3. Trang sản phẩm Noel: khung hạn đặt + câu quà tặng ngay dưới nút Add to cart chính (trước khối "One more to love" / shipping).
        Sản phẩm có cả bản thường (vịt, bulldog): chỉ hiện khi ô Type đang chọn là bản Christmas. */
  const pm = location.pathname.match(/^[/]products[/]([^/?#]+)/);
  const product = pm && items.get(pm[1]);
  if (product) {
    const wantBox = () => {
      if (!product.mixed) return true;
      return [...document.querySelectorAll('variant-picker input[type=radio]:checked')].some(i => /christmas/i.test(i.value))
        || [...document.querySelectorAll('lv-r12-gallery [aria-pressed="true"], lv-r12-gallery .is-active')].some(e => /christmas/i.test(e.textContent));
    };
    const mount = () => {
      try {
        let box = document.querySelector('[data-lv-noel-box]');
        if (!wantBox()) { if (box) box.style.display = 'none'; return; }
        if (!box) {
          const main = document.querySelector('product-form.m-product-form--main');
          const ship = document.querySelector('.main-product__block-shipping');
          if (!main && !ship) return;
          box = document.createElement('div');
          box.className = 'lv-noel-box';
          box.setAttribute('data-lv-noel-box', '');
          box.setAttribute('data-lv-hide-late', '');
          box.innerHTML = '<p class="lv-noel-box__dl"><span aria-hidden="true">&#127876;</span> <strong data-lv-dl></strong> <span class="lv-noel-box__left" data-lv-left></span></p>'
            + '<p class="lv-noel-box__gift"><strong>Pick one to gift, one to keep.</strong> Buy 2 sets: FREE US shipping. 3+ sets: extra $5 off.</p>'
            + '<p class="lv-noel-box__note" data-lv-note></p>';
          if (main) main.insertAdjacentElement('afterend', box); else ship.parentNode.insertBefore(box, ship);
        }
        box.style.display = '';
        paint();
      } catch (e) { /* bỏ qua */ }
    };
    mount();
    document.addEventListener('change', () => setTimeout(mount, 60), true);
    document.addEventListener('click', () => setTimeout(mount, 120), true);
    window.addEventListener('load', () => setTimeout(mount, 300));
  }
})();